import * as vp from 'vopay';

type UpdateAuthorizedIpsRows = {
  label: vp.UpdateAuthorizedIpsLabel;
  id: vp.UpdateAuthorizedIpsId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const buildUpdateAuthorizedIpsRows = (): UpdateAuthorizedIpsRows[] => [
  {
    label: vp.UpdateAuthorizedIpsLabel.AuthorizedIPs,
    id: vp.UpdateAuthorizedIpsId.AuthorizedIPs,
    preset: 'text',
    required: true,
  },
];
export default buildUpdateAuthorizedIpsRows;
